import { Modal, Spin, Table } from 'antd'
import React, { useState } from 'react'
import { BiEditAlt } from 'react-icons/bi';
import { LoadingOutlined } from "@ant-design/icons";
import { render } from '@testing-library/react';
import AddFamilyMember from './AddFamilyMember';

function FamilyList({handlFamEdit, famList, isLoading,videoRef,stopCamera }) {
    const [familyMemModal, setFamilyMemModal] = useState(false);
    const [selectedMem,setSelectedMem] = useState(null);
    const loadingIcon = <LoadingOutlined style={{ fontSize: 40 }} spin />;

    const handleCloseModal = () => {
        setFamilyMemModal(!familyMemModal);
        stopCamera();
    }

    const handleEdit = (record) => {
        setFamilyMemModal(!familyMemModal);
        setSelectedMem(record);
    }

    const columns = [
        {
            title: "Name",
            dataIndex: "",
            render: (text, record) => `${record.firstName} ${record.lastName}`,
            sorter: {
                compare: (a, b) => a.firstName.localeCompare(b.firstName),
            },
        },
        {
            title: "Relation",
            dataIndex: "relationDescription",
        },
        {
            title: 'Edit',
            render: (text, record) => (
                <button className='cursor-pointer disabled:cursor-not-allowed disabled:opacity-50' onClick={() => handleEdit(record)}>
                    <BiEditAlt className='text-brand-successColor md:text-lg text-sm' />
                </button>
            ),
        }

    ];

    return (
        <div>
            <div className="flex flex-col h-screen justify-between">
                <div className="w-full" id="unquie-scroll">
                    <Table
                        columns={columns}
                        dataSource={famList}
                        loading={{
                            spinning: isLoading,
                            indicator: <Spin indicator={loadingIcon} size="large" />,
                        }}
                        pagination={{
                            pageSize: 10,
                            position: ["bottomCenter"],
                        }}
                        scroll={{ x: "max-content", y: false }}
                    />
                </div>
            </div>
            <Modal
                title="Edit Family Member"
                open={familyMemModal}
                footer={[]}
                onCancel={handleCloseModal}
                width="60%"
                destroyOnClose
            >
                <AddFamilyMember handlFamEdit={handlFamEdit} videoRef={videoRef} data={selectedMem} onClose={handleCloseModal} />
            </Modal>
        </div>
    )
}

export default FamilyList